import * as types from './typeNames'
import axios from 'axios'
import qs from 'qs'
import LZString from 'lz-string'
import { baseURL } from './base'
import { changeView, QUIZ_SUBMISSION_VIEW } from './main'
import { setSettings } from './settings'


export const getPresentations = formId => dispatch => {
    const url  = `${baseURL}/presentations/${formId}`
    
    return axios.get(url)
                .then(response => {
                    if(response.data && response.data.status === "success"){
                        dispatch(setPresentationList(response.data.data))
                        dispatch(getAnswers(formId, -1, 1, 20))
                    }else{
                        dispatch(()=>({type:"error", error:{message:"Server Error..."}}))
                    }                   
                })
                .catch(err => { console.log(err); dispatch(()=>({type:"error", err})) })
                .then(()=>{console.log("Get List Request Finished!");})
}


export const getAnswers = (formId, presId, page, pageSize) => dispatch => {
    dispatch(setAnswersLoader(true))
    const url  = `${baseURL}/answers/${formId}?pid=${presId}&page=${page}&pageSize=${pageSize}`
    return axios.get(url)
                .then(response => {
                    if(response.data && response.data.status === "success"){
                        dispatch(setAnswerList(response.data.data.answers, response.data.data.total, page))
                    }else{
                        dispatch(()=>({type:"error", error:{message:"Server Error..."}}))
                    }
                })
                .catch(err => {console.log(err); dispatch(()=>({type:"error", err}))})
                .then(() => {
                    console.log("Get Answers Done!");
                    dispatch(setAnswersLoader(false))
                })
}

export const getQuizResultsById = (quizId, page, pageSize)=> dispatch => {
    const url = `${baseURL}/QuizAnswers`
    const data = {
        quizId: quizId
    }
    if (page) {
        data.page = page;
    }
    if (pageSize) {
        data.pageSize = pageSize;
    }
    return axios.post(url, qs.stringify(data))
        .then(response => {
            if (response.data.status === 'success') {
                console.log("Result Create: ", response.data.data)
                //dispatch(setSettings(response.data.data, null, null))
                dispatch(setAnswerList(response.data.data.answers, response.data.data.total, page || 1))
            }
            else {
                console.log(response.data)
                dispatch(() => ({ type: "error", err: response.data.error }))
            }
        })
        .catch(err => { console.log(err); dispatch(() => ({ type: "error", err })) })
        .then(() => { console.log("Get Quiz Results Request Finished!"); dispatch(changeView(QUIZ_SUBMISSION_VIEW)) })
}

const setPresentationList = presentations => ({
    type: types.SET_PRESENTATION_LIST,
    presentations
})

const setAnswerList = (answers, total, page) => ({
    type: types.SET_ANSWER_LIST,
    answers,
    total,
    page
})

export const selectPresentation = presentation => ({
    type: types.SELECT_PRESENTATION,
    presentation
})

export const selectAnswer = answer => dispatch => {
    dispatch({
        type: types.SELECT_ANSWER,
        answer
    })
    const url  = `${baseURL}/answer/${answer.ResponseId}`
    return axios.get(url)
                .then(response => {
                    if(response.data && response.data.status === "success"){
                        let answer = response.data.data;
                        let elements = JSON.parse(LZString.decompressFromBase64(answer.Elements))
                        answer.decryptedElements = elements;
                        dispatch(setAnswer(answer))
                    }else{
                        dispatch(()=>({type:"error", error:{message:"Server Error..."}}))
                    }
                })
                .catch(err => {console.log(err); dispatch(()=>({type:"error", err}))})
                .then(() => {console.log(`Get Answer ${answer.ResponseId} Done!`);})
}


export const selectQuizAnswer = answer => dispatch => {
    dispatch({
        type: types.SELECT_ANSWER,
        answer
    })
    const url = `${baseURL}/quizanswer/${answer.ResponseId}`
    return axios.get(url)
                .then(response => {
                    if(response.data && response.data.status === "success"){
                        let answer = response.data.data;
                        let elements = JSON.parse(LZString.decompressFromBase64(answer.Elements))
                        answer.decryptedElements = elements;
                        dispatch(setAnswer(answer))
                    }else{
                        dispatch(()=>({type:"error", error:{message:"Server Error..."}}))
                    }
                })
                .catch(err => {console.log(err); dispatch(()=>({type:"error", err}))})
                .then(() => {console.log(`Get Answer ${answer.ResponseId} Done!`);})
}



export const setAnswer = answerModel => ({
    type: types.SET_ANSWER,
    answerModel
})

const setAnswersLoader = flag => ({
    type: types.SET_ANSWERS_LOADER,
    flag
})